import React from "react";

const IAPWrapper = ({}) => {
  return null;
};

export { IAPWrapper };
